import React from 'react';
import PropTypes from 'prop-types';
import { userShare } from '@/api';
import { withRouter } from 'react-router-dom';
import Work from '@/components/Work';
import Logo from '@/assets/images/share/logo.png';
import { LIBRARY_ASSETS_ORIGIN_URL } from '@/constants';
import './style.less';

@withRouter
class ShareWork extends React.Component {
  static propTypes = {
    match: PropTypes.object,
  };

  constructor() {
    super();
    this.state = {
      params: null,
      imgSrc: null,
    };
    this.work = React.createRef();
  }

  componentDidMount() {
    this.setState({ params: this.props.match ? this.props.match.params : null }, () => {
      this.getUserShare();
    });
  }

  getUserShare = async () => {
    const { params } = this.state;
    const result = await userShare.list(params.shareId, params.id, params.attempt);
    this.init(result && result.data);
  };

  init = (list) => {
    const { current } = this.work;
    const host = `${LIBRARY_ASSETS_ORIGIN_URL}resource/`;
    const imgSrc = `${host}img/reachout/${list[0].share_source[0].image_name}`;
    this.setState({ imgSrc });
    current.setDisabled();
    list
      ? current.settValue(
        list[0].share_word_from,
        list[0].share_word_to,
        list[0].share_word_content,
      )
      : current.settValue('', '', '');
  }

  render() {
    return (
      <div className="share-work-container">
        <div className="share-work">
          <div className="share-work-wrapper">
            <div className="share-work-header">
              <img src={Logo} alt="" />
            </div>
            <Work ref={this.work} />
            <div className="share-pic">
              <img src={this.state.imgSrc} alt="" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default ShareWork;
